import React from "react";

// Expandable table headers.
export const CAMPAIGN_METRICS_COLUMNS = [
  {
    name: <span className="fw-bold">Campaign Name</span>,
    selector: (row) => row.campaignTitle,
  },
  {
    name: (
      <div className="fw-bold d-flex align-items-center">
        <div className="sms-delivered h2 pt-2 pe-1">•</div>
        <div> SMS Delivered</div>
      </div>
    ),
    selector: (row) => row.smsDelivered,
  },
  {
    name: (
      <div className="fw-bold d-flex align-items-center">
        <div className="emails-delivered h2 pt-2 pe-1">•</div>
        <div> Emails Delivered</div>
      </div>
    ),
    selector: (row) => row.emailDelivered,
  },
  {
    name: (
      <div className="fw-bold d-flex align-items-center">
        <div className="unique-customers h2 pt-2 pe-1">•</div>
        <div> Unique Customers</div>
      </div>
    ),
    selector: (row) => row.uniqueCustomers,
  },
];
